import { Chip } from '@stern-ui/ui';
import { formatLocalDateWithTimeZone, formatLocalDateTimeWithTimeZone } from '@stern-ui/utilities';
import { createColumnHelper } from '@tanstack/react-table';

import { DataTableObject, TableConfigType } from '@/components/PatientDataTable';
import { isUs } from '@/globalConsts';
import { formatSentenceCase } from '@/utils';

import { AllPatientListObject } from '../types';

const columnHelper = createColumnHelper<DataTableObject>();

const allListsColumns = [
	columnHelper.accessor('name', {
		header: () => 'Name',
		enableSorting: true,
	}),
	columnHelper.accessor('list_type', {
		header: () => 'Type',
		cell: (props) => {
			const listType = props.getValue() as string;
			return (
				<Chip
					value={formatSentenceCase(listType)}
					style={listType === 'dynamic' ? 'dynamic' : 'static'}
					size='sm'
					className='inline-block'
				/>
			);
		},
		enableSorting: true,
	}),
	columnHelper.accessor('patient_count', {
		header: () => 'No. patients',
		cell: (props) => {
			const rowData = props.row.original as AllPatientListObject;
			return (
				<>
					{props.getValue() as number}
					{rowData.list_type === 'dynamic' && rowData.new_count > 0 && (
						<Chip
							value={`+${rowData.new_count} new`}
							style='new'
							size='sm'
							className='inline-block ml-2'
						/>
					)}
				</>
			);
		},
		enableSorting: true,
	}),
	columnHelper.accessor('created_at', {
		header: () => 'Created date',
		enableSorting: true,
		cell: (info) => {
			return formatLocalDateWithTimeZone(info.getValue() as string, isUs);
		},
	}),
	columnHelper.accessor('refreshed_at', {
		header: () => 'Last update',
		enableSorting: true,
		cell: (info) => {
			return formatLocalDateTimeWithTimeZone(info.getValue() as string, isUs);
		},
	}),
	columnHelper.accessor('created_by', {
		enableSorting: true,
		header: () => 'Created by',
	}),
];

const allListRowProps = {
	rowSelect: true,
	onRowClickTarget: '/patient-lists/lists/',
	getRowId: (row: AllPatientListObject) => `${row.id}`,
	onClickClearStateValues: { tabValue: 0 },
};

export const allListTableConfig: TableConfigType = {
	columns: allListsColumns,
	rowProps: allListRowProps,
};
